export const WP_TANDC_REQUEST = 'wp_terms_and_conditions_fetch';
export const WP_TANDC_SUCCESS = 'wp_terms_and_conditions_success';
export const WP_TANDC_FAILURE = 'wp_terms_and_conditions_failure';
